import React from 'react'
import { motion } from "framer-motion";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Header from '../component/Header';
import Footer from '../component/Footer';
import QR from '../assets/qr.jpeg';

export default function Paynow() {
  // const steps = [
  //   {
  //     icon: '01',
  //     title: 'Access the Repayment Section',
  //     description: 'Click on the Repay Loan option available on the B4Salary website or the repayment link shared directly with you.',

  //   },
  //   {
  //     icon: '02',
  //     title: 'Enter Account Details',
  //     description: 'Enter your PAN or registered details so we can retrieve your loan account information.',

  //   },
  //   {
  //     icon: '03',
  //     title: 'Confirm Your Identity',
  //     description: 'A verification OTP will be sent to your registered mobile number. Enter it to confirm your identity securely.',

  //   },
  //   {
  //     icon: '04',
  //     title: 'Review Loan Information',
  //     description: 'View your outstanding balance, due amount, and repayment information for your account.',

  //   },
  //   {
  //     icon: '05',
  //     title: 'Select Repayment Amount',
  //     description: 'Choose whether you would like to make a full payment or continue with a partial payment option.',
  //   },
  //   {
  //     icon: '06',
  //     title: 'Continue to Payment',
  //     description: 'Select Pay Now and choose your preferred payment method, such as UPI, credit card, debit card, or netbanking.',
  //   },
  //   {
  //     icon: '07',
  //     title: 'Get Payment Confirmation',
  //     description: 'Once your payment is successfully completed, confirmation details will be sent via SMS and to your registered email address.',
  //   }

  // ];
  // return (
  //   <div>
  //     <Header />
  //     {/* banner section start */}
  //     <div className="relative h-[500px] flex items-center justify-center bg-gradient-to-br from-[#0b1f3a] to-[#0a2540] overflow-hidden">
  //       {/* Animated Background Glow */}
  //       <div className="absolute w-[400px] h-[400px] bg-blue-500/20 rounded-full blur-3xl animate-pulse top-[-100px] left-[-100px]" />
  //       <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-80px] right-[-80px]" />

  //       {/* Glass Card */}
  //       <motion.div
  //         initial={{ opacity: 0, y: 40 }}
  //         animate={{ opacity: 1, y: 0 }}
  //         transition={{ duration: 0.8 }}
  //         className="px-10 py-8 text-center "
  //       >
  //         <div className="w-full max-w-lg mx-auto bg-white rounded-2xl shadow-lg border border-slate-200 p-6 sm:p-8">

  //           {/* Heading */}
  //           <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
  //             Repay Loan
  //           </h2>

  //           {/* Description */}
  //           <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">
  //             Kindly verify your details before proceeding with your loan repayment. For repayment-related queries or support assistance, please contact us at
  //             {" "}
  //             <span className="font-medium text-orange-500">
  //               care@b4salary.com.
  //             </span>
  //           </p>

  //           {/* Sub Heading */}
  //           <h5 className="mt-5 text-sm sm:text-base font-medium text-slate-800">
  //            Log in securely using your PAN and OTP to access your loan details and continue with repayment.
  //           </h5>

  //           {/* Input */}
  //           <div className="mt-5">
  //             <input
  //               type="text"
  //               placeholder="Enter PAN No."
  //               className="w-full h-12 rounded-xl border border-slate-300 bg-white px-4 text-sm text-slate-800 placeholder:text-slate-400 outline-none transition-all focus:border-orange-500 focus:ring-4 focus:ring-orange-100"
  //             />
  //           </div>

  //           {/* Button */}
  //           <button className="mt-5 w-full h-12 rounded-xl bg-orange-500 text-white font-medium hover:bg-orange-600 transition-all duration-300">
  //             Continue
  //           </button>
  //         </div>


  //       </motion.div>
  //     </div>

  //     {/* end */}

  //     <div className='max-w-7xl m-auto'>
  //       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4 py-15 ">
  //         {steps.map((doc, index) => (
  //           <div
  //             key={index}
  //             className="bg-white border-2 border-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow"
  //           >
  //             <div className="w-12 h-12 bg-orange-300 rounded-full flex items-center justify-center mb-4 font-bold text-2xl">
  //               {/* <doc.icon className="w-6 h-6 text-white" /> */}
  //               {doc.icon}
  //             </div>
  //             <h3 className="text-xl font-semibold text-slate-600 mb-2">
  //               {doc.title}
  //             </h3>
  //             <p className="text-sm text-slate-600 mb-4 leading-relaxed">
  //               {doc.description}
  //             </p>


  //           </div>
  //         ))}

  //         <div className="bg-gradient-to-br from-slate-800 to-teal-800 rounded-lg p-6 text-white flex flex-col justify-between">
  //           <div>
  //             <div className="w-12 h-12 bg-teal-500/30 rounded-full flex items-center justify-center mb-4">
  //               <SupportAgentIcon className="w-6 h-6 text-teal-300" />
  //             </div>
  //             <h3 className="text-xl font-semibold mb-3">Need Help?</h3>
  //             <p className="text-sm text-slate-300 mb-6 leading-relaxed">
  //               Our loan support team is available 24/7 to assist you with repayment-related queries and help you with any account-related concerns.
  //             </p>
  //           </div>
  //           <button className="w-full bg-white text-slate-900 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors">
  //             Speak with an Expert
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //     <Footer/>
  //   </div>

  return(
    <>
    <Header/>
    <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr]">
        {/* Left Section */}
        <div className="px-24 py-24">
          <h1 className="text-[22px] font-semibold text-[#4b5fd1] mb-8">
            Bank Account Details
          </h1>

          <div className="space-y-10">
            {/* Row */}
            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Account Name
              </p>
              <p className="text-15px text-gray-700 leading-relaxed">
                KISGA LEASING AND FINANCE PRIVATE LIMITED -B4Salary
              </p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Account No.
              </p>
              <p className="text-15px text-gray-700">135305003842</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Bank Name
              </p>
              <p className="text-15px text-gray-700">ICICI Bank</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                IFSC Code
              </p>
              <p className="text-15px text-gray-700">ICIC0001353</p>
            </div>

            <div className="grid grid-cols-2 border-b border-gray-300 pb-1">
              <p className="text-15px font-semibold text-gray-600">
                Branch Address
              </p>
              <p className="text-15px text-gray-700">
                NETAJI SUBHASH PLACE, DELHI, INDIA
              </p>
            </div>

            <div className="grid grid-cols-2 pb-5">
              <p className="text-15px font-semibold text-gray-600">
                Account Type
              </p>
              <p className="text-15px text-gray-700">Current</p>
            </div>
          </div>

          {/* Footer Note */}
          <p className="mt-16 text-[20px] text-gray-700 leading-relaxed max-w-6xl">
            Please ensure the above details are used for official payments
            only. For UPI transfers, you may scan the QR code provided.
          </p>
        </div>

        {/* Right Section */}
        <div className="justify-center items-start py-8">
          <div >
            {/* Replace with actual image */}
            <img
              src={QR}
              alt="QR Payment"
              className="w-80 object-contain"
            />
          </div>
        </div>
    </div>
    
    </>
  )
  
}
